<template>
  <VDialog
    v-model="visible"
    max-width="400"
  >
    <template #activator="{ on }">
      <slot name="activator" :show="show" />
    </template>
    <VCard>
      <VCardTitle class="headline" />
      <VCardText>
        {{ $t('fillCompanyInfo') }}
      </VCardText>

      <VCardActions class="d-flex justify-center">
        <VBtn
          color="success"
          :to="{ name: 'company' }"
          @click="close"
        >
          {{ $t('fill') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'VacancyStoreDialog',
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  fillCompanyInfo: You must fill the company information before posting a job
  fill: Fill in
</i18n>

<i18n locale="ru" lang="yaml">
  fillCompanyInfo: Прежде чем разместить вакансию, необходимо заполнить информацию о компании
  fill: Заполнить
</i18n>
